import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function Trunk2Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M2.3929 7.69777C2.94852 7.34207 3.67532 7.40264 4.16047 7.84525L7.37425 10.7768L8.68778 10.7769L9.35664 10.2406L5.36205 6.59668C4.28185 5.61148 2.66377 5.47638 1.42716 6.2683C1.02173 6.52796 0.909202 7.05846 1.17597 7.45317C1.44274 7.84793 1.98765 7.95726 2.3929 7.69777Z"
        fill="currentColor"
      />
      <path
        d="M30.1213 5H23.9834C21.6111 5 19.2787 5.55867 17.189 6.60444V10.7539H31V5.85546C30.9999 5.38302 30.6065 5 30.1213 5Z"
        fill="currentColor"
      />
      <path
        d="M15.4316 7.64C15.1282 7.84793 11.4806 10.7539 11.4806 10.7539H15.4316V7.64Z"
        fill="currentColor"
      />
      <path
        d="M2.46021 13.3049C1.91888 13.8319 1.62071 14.5326 1.62071 15.2781V15.4648H5.65261V12.4876H4.48688C3.7213 12.4876 3.00148 12.7779 2.46021 13.3049Z"
        fill="currentColor"
      />
      <path
        d="M14.3815 23.8505C14.8667 23.8505 15.2601 23.4675 15.2601 22.9951C15.2601 22.5226 14.8667 22.1396 14.3815 22.1396C13.8962 22.1396 13.5028 22.5226 13.5028 22.9951C13.5028 23.4675 13.8962 23.8505 14.3815 23.8505Z"
        fill="currentColor"
      />
      <path
        d="M14.3814 17.9901C11.5422 17.9901 9.24053 20.2309 9.24053 22.9951C9.24053 25.7592 11.5422 28 14.3814 28C17.2206 28 19.5223 25.7592 19.5223 22.9951C19.5223 20.2309 17.2206 17.9901 14.3814 17.9901ZM14.3815 25.5614C12.9279 25.5614 11.7454 24.4102 11.7454 22.9951C11.7454 21.58 12.9279 20.4287 14.3815 20.4287C15.835 20.4287 17.0175 21.58 17.0175 22.9951C17.0175 24.4102 15.835 25.5614 14.3815 25.5614Z"
        fill="currentColor"
      />
      <path
        d="M7.62386 21.6368H1.87869C1.39342 21.6368 1 22.0198 1 22.4923V24.2704C1 24.7429 1.39342 25.1259 1.87869 25.1259H7.83609C7.60394 24.4479 7.48315 23.7306 7.48315 22.9951C7.48315 22.5334 7.53107 22.0789 7.62386 21.6368Z"
        fill="currentColor"
      />
      <path
        d="M21.2797 22.9951C21.2797 23.7213 21.162 24.43 20.9355 25.1005L30.1158 25.082C30.6003 25.081 30.9927 24.6983 30.9927 24.2266V21.653C30.9934 21.6476 30.9937 21.6422 30.9943 21.6368H21.139C21.2318 22.0789 21.2797 22.5334 21.2797 22.9951Z"
        fill="currentColor"
      />
      <path
        d="M7.40999 16.3203C7.40999 16.7927 7.01657 17.1757 6.5313 17.1757H1.62071V19.9259H8.2424C8.56622 19.3136 8.98905 18.7473 9.50367 18.2462C10.8066 16.9778 12.5389 16.2792 14.3815 16.2792C16.224 16.2792 17.9563 16.9778 19.2592 18.2462C19.7738 18.7473 20.1967 19.3136 20.5205 19.9259H30.9999V12.4648L7.40999 12.4878V16.3203ZM25.5535 15.8782H26.5767C27.062 15.8782 27.4554 16.2612 27.4554 16.7337C27.4554 17.2061 27.062 17.5891 26.5767 17.5891H25.5535C25.0682 17.5891 24.6748 17.2061 24.6748 16.7337C24.6748 16.2612 25.0682 15.8782 25.5535 15.8782Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
